import {ImportingDataTypes} from "../../types";
import {createInvalidExternalCustomerCodeSection, PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.externalCustomers,
    sections: [
        {
            sectionKey: 'missingCustomerFields',
            sectionTitle: 'Missing Customer Code or ID',
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                createInvalidExternalCustomerCodeSection().fields[0],
                {
                    key: 'internalId',
                    label: 'Internal ID',
                    type: 'input',
                    modifyRow: (row, val) => ({...row, internalId: val})
                }
            ]
        },
        {
            sectionKey: 'invalidAddUser',
            sectionTitle: 'Invalid Create User Values',
            invalidityCode: PreventionInvalidityCode.INVALID_BOOLEAN,
            fields: [{
                key: 'addUser',
                label: 'Create User',
                type: 'toggle',
                modifyRow: (row, val) => ({...row, addUser: val})
            }]
        }
    ],
};
